/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ field: NonNullable<unknown> }} Case_Step_Field_Requirement_LabelInputs */

const en_case_step_field_requirement_label = /** @type {(inputs: Case_Step_Field_Requirement_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.field === "claimant_driver_cnh") return /** @type {LocalizedString} */ (`Record the claimant driver's CNH`);
	if (i?.field === "vehicle_owner") return /** @type {LocalizedString} */ (`Record the vehicle owner`);
	return /** @type {LocalizedString} */ (`${i?.field}`)
	
};

const pt_br2_case_step_field_requirement_label = /** @type {(inputs: Case_Step_Field_Requirement_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.field === "claimant_driver_cnh") return /** @type {LocalizedString} */ (`Registrar a CNH do condutor requerente`);
	if (i?.field === "vehicle_owner") return /** @type {LocalizedString} */ (`Registrar o proprietário do veículo`);
	return /** @type {LocalizedString} */ (`${i?.field}`)
	
};

/**
* | field | output |
* | --- | --- |
* | "claimant_driver_cnh" | "Record the claimant driver's CNH" |
* | "vehicle_owner" | "Record the vehicle owner" |
* | * | "{field}" |
*
* @param {Case_Step_Field_Requirement_LabelInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_step_field_requirement_label = /** @type {((inputs: Case_Step_Field_Requirement_LabelInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Step_Field_Requirement_LabelInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_step_field_requirement_label(inputs)
	return pt_br2_case_step_field_requirement_label(inputs)
});